import React from 'react';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {translations} from 'presentation/translations-new';
import {Navigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useFranchisesTable} from './hooks';
import {useAccountInformation} from '../hooks';

const {title} = translations['pt-br'].privateFlow.franchisesTable;

export function FranchisesTableWrapper() {
	const {handleBack} = useFranchisesTable();
	const {isGndiSaoPaulo} = useHostName();
	const {healthOnly} = useAccountInformation();

	if (!isGndiSaoPaulo || healthOnly) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return (
		<PageWrapperLayout title={title}>
			<MainHeader title={title} handleBack={handleBack} hideClose variant={'subRoute'} />
		</PageWrapperLayout>
	);
}
